var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArticleSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.454,
    height: 19,
    viewBox: "0 0 21.454 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#7f7f7f;stroke-linecap:round;stroke-linejoin:round;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M2.223,8.609h0A2.1,2.1,0,0,0,4.447,6.652V.783A.841.841,0,0,0,3.557,0H0V6.652A2.1,2.1,0,0,0,2.223,8.609Z",
    transform: "translate(16.007 9.391)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M16.008,15.652V.783A.841.841,0,0,0,15.119,0H.889A.841.841,0,0,0,0,.783V15.652A2.523,2.523,0,0,0,2.668,18H17.787",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 8.893,
    transform: "translate(3.557 12.522)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 8.893,
    transform: "translate(3.557 14.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 10.672,
    height: 5.478,
    transform: "translate(2.667 3.13)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArticleSearch);
export default __webpack_public_path__ + "static/media/article-search.2a283952889aed73f1813390735cc76f.svg";
export { ForwardRef as ReactComponent };